module.exports = {
  chargePartTypeKG: '按重量(KG)划分',
  chargePartTypeCBM: '按体积(CBM)计费',
  chargePartTypeTipsL1: 'tips：什么是计费区间类型？',
  chargePartTypeTipsL2: '按重量(KG)划分表示货物的重量不同，运费价格不同。',
  chargePartTypeTipsL3: '按体积(CBM)划分表示货物的体积不同，运费价格不同。'
}
